export enum PropertyTableColumn {
  CHECKBOX = 'checkbox',
  TITLE = 'title',
  ADDRESS = 'address',
  CREATED_AT = 'created_at',
  LAST_UPDATED_AT = 'last_updated_at',
  PROPERTY_MANAGER = 'property_manager',
  ACTION = 'action'
}

export const propertiesTableHead = [
  PropertyTableColumn.CHECKBOX,
  PropertyTableColumn.TITLE,
  PropertyTableColumn.ADDRESS,
  PropertyTableColumn.CREATED_AT,
  PropertyTableColumn.LAST_UPDATED_AT,
  PropertyTableColumn.PROPERTY_MANAGER,
  PropertyTableColumn.ACTION
]
